// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Xes","newExpiryDate":"styles_newExpiryDate__2l9JL","footer":"styles_footer__3hgJF"};